
export const diContainers = {
    default: { }
}

export function diRegister(config: { [key: string]: any }, replace = false, container = "default") {
    for (const key in config) {
        let instance = config[key];
        if (!replace) {
            instance = diContainers[container][key] || instance;
        }
        diContainers[container][key] = instance;
    }
}


export function tryResolve(key, container = "default") {
    const diContainer = diContainers[container];
    if (diContainer) {
        return diContainer[key];
    }
    return null;
}

export function diResolve(key, container = "default") {
    const bean = tryResolve(key, container);
    if (bean) {
        return bean;
    } else {
        console.error(`Context "${container}" has no bean with name ${key}. 
                    Available beans: ${Object.getOwnPropertyNames(diContainers[container]).join(', ')}`);
    }
}

/**
 * 定义一个修饰器，依赖注入
 * @param injectKey 对象的key 
 */
export function diInject(injectKey = null): any {
    return function (target: any, propertyKey: string, container = "default") {
        Object.defineProperty(target, propertyKey, {
            get() {
                var key = injectKey || propertyKey;
                const bean = diResolve(key, container);
                if (bean) {
                    return bean;
                } else {
                    console.error(`Context "${container}" has no bean with name ${key}. 
                    Available beans: ${Object.getOwnPropertyNames(diContainers[container]).join(', ')}`);
                }
            },
            set() {
                throw new Error('Not allowed');
            },
            enumerable: true,
            configurable: true
        });
    };
};


export function diInjectWithClass(injectKey = null): any {
    return function (target: any, propertyKey: string, container = "default") {
        Object.defineProperty(target, propertyKey, {
            get() {
                var key = injectKey || propertyKey;
                const bean = diResolve(key, container);
                if (bean) {
                    return new bean();
                } else {
                    console.error(`Context "${container}" has no bean with name ${key}. 
                    Available beans: ${Object.getOwnPropertyNames(diContainers[container]).join(', ')}`);
                }
            },
            set() {
                throw new Error('Not allowed');
            },
            enumerable: true,
            configurable: true
        });
    }; 
}


// WEBPACK FOOTER //
// ./src/stores/diContext.ts